/* eslint-disable max-len */
import React from 'react';

import Icon from './index';

interface Props {
  className?: string;
}

// Three stacked horizontal bars with a downward arrow on the right, suggesting
// "rows collapse together when the middle one is removed". Matches the visual
// language of the other dropdown icons (line-art, 20×20).
function IconAddReflow({ className }: Props) {
  return (
    <Icon className={className}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="11" height="2" rx="1" fill="#212121" />
        <rect x="3" y="9" width="11" height="2" rx="1" fill="#212121" opacity="0.4" />
        <rect x="3" y="14" width="11" height="2" rx="1" fill="#212121" />
        <path
          d="M16.5 6.5 V13.5 M16.5 13.5 L15 12 M16.5 13.5 L18 12"
          stroke="#212121"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
}

export default React.memo(IconAddReflow);
